import {atomWithStorage} from 'jotai/utils';
import {AddressSearchHistoryItem} from '../@types';

export const mapAddressSearchHistoryAtom = atomWithStorage<
  AddressSearchHistoryItem[]
>('map/addr-search/history-list', []);
